jQuery(document).ready(function ($) {
  console.log('Trader-child Theme');
});

// Brand video in the homepage header (add_brand_video() in inc/Theme.php). It only gets a source
// after the page has loaded, so the poster image stays the first thing to paint. Visitors who
// prefer reduced motion or save data keep the poster.
window.addEventListener('load', async () => {
  const video = document.querySelector('.brand-video');
  if (!video) {
    return;
  }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) {
    return;
  }

  // Same breakpoint as the 3:4 mobile header in _cover.scss.
  const isPhone = window.matchMedia('(max-width: 768px)').matches;
  video.src = isPhone && video.dataset.srcPhone ? video.dataset.srcPhone : video.dataset.src;
  video.muted = true;
  video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });

  try {
    await video.play();
  } catch {
    // Autoplay refused (Low Power Mode, for one): keep the poster and stop the download.
    video.removeAttribute('src');
    video.load();
  }
});
